import React, { useState } from "react";
import axios from "axios";
import { Modal, Box, Typography } from "@mui/material";
import { toast } from "react-toastify";
import { ReactComponent as CLoseIcon } from "./DummyIcons/CloseButton.svg";

const ServiceAdditionOnTheGo = ({ open, onClose, onCreated }) => {
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [fee, setFee] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [unit, setUnit] = useState("1");
  const [hipId, setHipId] = useState(sessionStorage.getItem("facility_name") || "");
  const [loading, setLoading] = useState(false);

  const authToken = sessionStorage.getItem("accessToken");

  const headers = {
    Authorization: `Bearer ${authToken}`,
  };

  const resetForm = () => {
    setName("");
    setDescription("");
    setFee("");
    setExpiryDate("");
    setUnit("1");
    setHipId(sessionStorage.getItem("facility_name") || "");

  };
  console.log("RAW STATES =>", {
    name,
    description,
    fee,
    expiryDate,
    unit,
    hipId
  });
  const handleSave = async () => {
    if (!name || !fee || !unit || !hipId) {
      toast.error("Please fill all required fields");
      return;
    }
    const payload = {
      name: name.trim(),
      description: description.trim(),
      fee: Number(fee),
      unit: unit.trim(),
      hip_id: hipId.trim(),
      ...(expiryDate ? { expiry_date: expiryDate } : {}),
    };

    console.log("FINAL PAYLOAD =>", payload);
    try {
      setLoading(true);

      const res = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}add_new_medical_service/`,
        payload,
        { headers }
      );

      if (res?.data?.status === "Success") {
        toast.success("Service created successfully");
        onCreated && onCreated(res.data.services);
        resetForm();
        onClose();
      } else {
        toast.error(res?.data?.message || "Failed to create service");
      }

    } catch (err) {
      console.error(err);
      toast.error("Failed to create service");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <Box
        sx={{
          width: { xs: "100%", sm: "75%", md: "50%", lg: "35%" },
          mt: 3,
          mx: "auto",
          bgcolor: "background.paper",
          borderRadius: "10px",
          padding: 0,
        }}
      >

        {/* HEADER */}
        <Box
          sx={{
            backgroundColor: "#213360",
            height: 60,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 2,
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
          }}
        >
          <Typography sx={{ fontSize: 20, fontWeight: 550, color: "#fff" }}>
            Add New Service
          </Typography>

          <CLoseIcon
            onClick={() => {
              resetForm();
              onClose();
            }}
            style={{ width: 20, height: 20, cursor: "pointer" }}
          />
        </Box>

        {/* BODY */}
        <Box sx={{ p: 2 }}>

          <label className="required-label">Name</label>
          <input
            className="form-control"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter Name"
          />

          <label>Description</label>
          <textarea
            className="form-control"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Enter Description"
          />

          <label className="required-label mt-2">Fee</label>
          <input
            type="number"
            className="form-control"
            value={fee}
            onChange={(e) => setFee(e.target.value)}
            onWheel={(e) => e.target.blur()}
            placeholder="Enter Fee"
          />

          <label className="mt-2">Expiry Date</label>
          <input
            type="date"
            className="form-control"
            value={expiryDate}
            onChange={(e) => setExpiryDate(e.target.value)}
          />

          {/* FOOTER */}
          <div className="d-flex mt-3" style={{ gap: "10px" }}>
            <button
              className="btn btn__secondary btn__block"
              style={{ flex: 1 }}
              onClick={handleSave}
              disabled={loading}
            >
              {loading ? "Saving..." : "SAVE"}
            </button>

            <button
              className="btn btn__secondary btn__block"
              style={{ flex: 1 }}
              onClick={() => {
                resetForm();
                onClose();
              }}
            >
              CANCEL
            </button>
          </div>

        </Box>
      </Box>
    </Modal>
  );
};

export default ServiceAdditionOnTheGo;
